import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Arrow } from 'assets/images/arrow-forw.svg';
import { ReactComponent as Car } from 'assets/images/autos/icon-car.svg';

export const Container = styled.div`
  display: flex;
  margin: 8px 0 0;
`;

export const CarIcon = styled(Car)`
  width: 16px;
  height: 16px;
  margin-top: 4px;
  margin-right: 10px;
`;

export const Title = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const ArrowIcon = styled(Arrow)`
  width: 16px;
  height: 16px;
  margin: 0 5px;
  vertical-align: middle;
`;
